import { isDebug } from './isDebug'

declare global {
    interface Window {
        dbg: any
    }
}

export function setDebugMode(): void {
    if (isDebug()) message()

    window.dbg = {
        on: setOn,
        off: setOff,
        toggle: setToggle,
        clean: setClean,
    }
}

function message(optionalMessage = '') {
    /* eslint-disable no-console */
    if (isDebug())
        console.log(
            '%c debugging mode ON ' + optionalMessage,
            'background: green; color: white'
        )
    else
        console.log(
            '%c debugging mode OFF ' + optionalMessage,
            'background: red; color: white'
        )
    /* eslint-enable no-console */
}

function setOn() {
    window.sessionStorage.setItem('debug', 'true')
    message()
}
function setOff() {
    window.sessionStorage.setItem('debug', 'false')
    message()
}
function setToggle() {
    window.sessionStorage.setItem('debug', isDebug() ? 'false' : 'true')
    message()
}
function setClean() {
    window.sessionStorage.removeItem('debug')
    message('(flag deleted from session storage)')
}
